import {hashCodeCertificate} from "./hoc/hashCodeCertificate";

const WaybillV2BulkConsignorCancel = hashCodeCertificate("WaybillV2BulkConsignorCancel")
export default WaybillV2BulkConsignorCancel